import React from 'react';
import { PrimaryButton, SecondaryButton, CriticalButton } from '@gjensidige/core-buttons';
import styles from './nav-button-group.module.less';
import { text } from '../../../utils/text';
import classNames from 'classnames';
export const NavigationButtons = ({ isSubmit = true, disableNext = false, disablePrevious = false, loading = false, onNext, onPrevious, onCancel, nextText, prevText, cancelText, trackingEventlabel, }) => {
    const trackingLabel = trackingEventlabel ? trackingEventlabel : nextText ? nextText : text.NAV_BUTTONS.NEXT.no;
    return (React.createElement("div", { className: classNames(styles.navBtnGroup) },
        React.createElement("div", null, (onNext || isSubmit) && (React.createElement(CriticalButton, { className: classNames({
                [styles.margin]: onPrevious || onCancel,
            }), disabled: disableNext, onClick: onNext, type: isSubmit ? 'submit' : 'button', loading: loading, tracking: {
                eventLabel: trackingLabel,
            } }, nextText ? nextText : text.NAV_BUTTONS.NEXT.no))),
        React.createElement("div", null,
            onPrevious && (React.createElement(PrimaryButton, { onClick: onPrevious, disabled: disablePrevious }, prevText ? prevText : text.NAV_BUTTONS.BACK.no)),
            onCancel && (React.createElement(SecondaryButton, { onClick: onCancel }, cancelText ? cancelText : text.NAV_BUTTONS.CANCEL.no)))));
};
